import {
    Component,
    Element,
    h,
    Host,
    Prop,
} from '@stencil/core';
import { ThemeType } from '@uipath/portal-shell-util';

import { MaterialIconVariant } from '../../models/portalActions';

@Component({
    tag: 'portal-icon',
    styleUrl: 'portal-icon.scss',
    shadow: true,
})
export class PortalIcon {
    @Element() el: HTMLPortalIconElement;

    /**
     * Name of the icon
     * @memberof PortalIcon
     */
    @Prop() name = '';

    /**
     * Aria Label of the icon
     * @memberof PortalIcon
     */
    @Prop() ariaLabel: ARIAMixin['ariaLabel'];

    /**
     * Size of the icon
     * @memberof PortalIcon
     */
    @Prop() size = '16px';

    /**
     * Color override of the icon
     * @memberof PortalIcon
     */
    @Prop() color = '';

    /**
     * Variation of the Icon
     * @memberof PortalIcon
     */
    @Prop() variant: MaterialIconVariant = 'normal';

    /**
    * Theme override to bypass store state
    * @memberof PortalIconButton
    */
    @Prop() theme: ThemeType = 'autoTheme';

    /**
     * The id of the icon
     * @memberof PortalIcon
     */
    @Prop() iconId: string;

    render() {
        return <Host class="portal-icon">
            <div
                style={{
                    width: this.size,
                    height: this.size,
                }}>
                <i class={
                    this.variant === 'normal' ?
                        'pt-material-icons material-icons' :
                        'pt-material-icons-outlined material-icons-outlined'

                }
                id={this.iconId}
                aria-label={this.ariaLabel}
                style={
                    {
                        fontSize: this.size,
                        width: this.size,
                        height: this.size,
                        lineHeight: this.size,
                        color: this.color,
                    }
                }>
                    {this.name}
                </i>
            </div>
        </Host>;
    }
}
